import OrderItem from '../OrderItem/order-item';

export default OrderItem;